// extracted by mini-css-extract-plugin
module.exports = {"title":"Share_title__1V86s","list":"Share_list__2di_T","link":"Share_link__1vw6K","label":"Share_label__3cXa4"};